import React, { useEffect, useState } from 'react';
import {connect} from "react-redux";
import { bool, func } from 'prop-types';
import ReCAPTCHA from "react-google-recaptcha";

import PanelContainer from '../../components/PanelContainer';
import { HeadWrapper, Button, Input } from '../../elements';
import FooterContainer from '../../components/FooterContainer/FooterContainer';
import { ReactComponent as Smile } from '../../styles/icon/smile.svg';
import { ReactComponent as GitHub } from '../../styles/icon/github.svg';
import { ReactComponent as Linkedin } from '../../styles/icon/linkedin.svg';
import support from './Support.module.scss';
import { showError } from '../../elements/Toasts/toastActions';
import strings from '../../lang/lang';
import {keycloak} from "../../keycloak-config";
import { submitSupportForm, toggleSupportMessage } from '../../redux/reducers/support';
import withAuth from '../../hocs/withAuth';

const mapStateToProps = (state) => ({
  profile: state.auth.profile,
  isSwitcherOpen: state.switcher.isSwitcherOpen,
  isActiveSupportMessage: state.support.isActiveSupportMessage,
  envVars: state.environment
});

const mapDispatchToProps = {
  toggleSupportMessage,
  submitSupportForm
};

const recaptchaRef = React.createRef();

Support.propTypes = {
  isSwitcherOpen: bool,
  isActiveSupportMessage: bool,
  toggleSupportMessage: func,
  submitSupportForm: func
};

function Support(props) {
  const [siteKey, setKey] = useState('');
  const [user, setUserDetails] = useState({});
  const { isSwitcherOpen, isActiveSupportMessage, envVars, toggleSupportMessage, submitSupportForm } = props;

  useEffect(() => {
    const captchaKey = envVars['REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY'];
    if (captchaKey) {
      setKey(captchaKey);
    }
  }, [envVars]);

  useEffect(() => {
    keycloak.loadUserInfo().then(userInfo => {
      handleUserData(userInfo);
    });
  }, []);

  function handleUserData(user) {
    const data = {};
    const userKey = Object.keys(user);
    userKey.forEach(key => {
      if (key === 'given_name') {
        data['firstName'] = user[key];
      }
      if (key === 'family_name') {
        data['lastName'] = user[key];
      }
      if (key === 'email') {
        data['email'] = user[key];
      }
    });
    setUserDetails(data);
  }

  function handleChange(event) {
    const data = {...user}
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    data[fieldName] = fieldValue;
    setUserDetails(data);
  };

  async function submitSupportRequest() {
    const token = await recaptchaRef.current.executeAsync();
    const data = {...user, recaptchaToken: token};

    return new Promise((res, rej) => {
      submitSupportForm({ data, res, rej });
    })
    .then((res) => {
      toggleSupportMessage({ status: true });
      const data = {...user};
      delete data.requestText;
      setUserDetails(data);
    })
    .catch((error) => {
      if (typeof error === 'string') {
        showError(error);
      } else {
        showError(strings.support.errors.submittingForm + error.message.replaceAll('\n', ', '));
      }
    });
  };

  return (
    <>
      <HeadWrapper
        href="https://developer.staq.io/support"
      />
      <PanelContainer />
      <div className={support.support} id="support">
        <div className={support.support__hold}>
          <h1>{strings.support.text.title}</h1>
          {!isActiveSupportMessage ? (
            <div className={support.support__container}>
              <p>
                {strings.formatString(strings.support.text.description, <a href="mailto:help@staq.io">help@staq.io</a>)}
              </p>
              <div className={support.support__inputs}>
                <div className={support.support__item}>
                  <Input
                    id="firstName"
                    name="firstName"
                    className="input__textfield__settings"
                    label={strings.support.fields.firstName}
                    value={user.firstName || ''}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
                <div className={support.support__item}>
                  <Input
                    id="lastName"
                    name="lastName"
                    className="input__textfield__settings"
                    label={strings.support.fields.lastName}
                    value={user.lastName || ''}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </div>
              </div>
              <Input
                id="email"
                name="emailAddress"
                className="input__textfield__settings"
                label={strings.support.fields.email}
                value={user.email || ''}
                disabled
                autoComplete="off"
              />
              <div className={support.support__textarea}>
                <textarea
                  id="supportComment"
                  name="requestText"
                  className="input__textarea"
                  value={user.requestText || ''}
                  onChange={handleChange}
                  placeholder={strings.support.text.supportCommentPlaceholder}
                  autoFocus="autofocus"
                  maxLength={2000}
                />
              </div>
              {siteKey && (
                <ReCAPTCHA
                  key={siteKey}
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={siteKey}
                  theme={!isSwitcherOpen ? 'light' : 'dark'}
                />
              )}
              <div className={support.support__btn_box}>
                <Button
                  name={strings.support.buttons.submit}
                  variant="primary"
                  secondaryClassName="lg"
                  onClick={submitSupportRequest}
                />
              </div>
            </div>
          ) : (
            <div className={support.support__box}>
              <div className={support.support__box_icon}>
                <Smile />
              </div>

              <h3>{strings.support.text.thankYou}</h3>
              <div className={support.support__btn_box}>
                <a href="https://github.com/staq-io" target="_blank">
                  <Button variant="secondary" name="GitHub">
                    <GitHub />
                  </Button>
                </a>
                <a href="https://www.linkedin.com/company/staq-io/" target="_blank">
                  <Button variant="secondary" name="linkedin">
                    <Linkedin />
                  </Button>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <FooterContainer />
    </>
  );
}



export default withAuth(connect(mapStateToProps, mapDispatchToProps)(Support));
